import React, { useEffect, useMemo } from 'react'
import { useInstData, useEventHandler } from 'tyan/public/hooks'
import { hasChangedValues, getFormValue, changeItemsValue, getChangedFieldsets } from 'tyan/public/utility'

const SpotPlanInfo = props => {
    const { setState, me } = useInstData(props, useMemo(() => ({
        state: {
            id: props.match.params.id || 0
        }
    }), []))

    const { showBody: Body } = props
    const { id } = me.state

    useEffect(() => {
        handleDidMount()
    }, [])

    const handleDidMount = () => {
        Tyan.doPostEvent('GetSpotPlan', {
            data: { id },
            onEnd: ({ errorMessage, optionsParas, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    setState({ optionsParas, initValues基本信息, changedValues基本信息: {} })
                }
            }
        })
    }

    const handleSave = () => {
        Tyan.doPostEvent({
            event: 'SaveSpotPlan',
            data: getChangedFieldsets(me, '基本信息', false),
            onEnd: ({ errorMessage, id }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    Ext.toast('保存成功')
                    window.history.back()
                }
            }
        })
    }

    const handlerClose = () => {
        window.history.back()
        //onClose()
    }

    const bChanged = () => {
        return hasChangedValues(me)
    }

    const bSave = () => {
        return bChanged() && getFormValue(me, '基本信息', '设备编号') && getFormValue(me, '基本信息', '点检类别') && getFormValue(me, '基本信息', '点检项目')
    }

    const handlerChange = () => {
        const 设备编号 = getFormValue(me, '基本信息', '设备编号')
        const 点检类别 = getFormValue(me, '基本信息', '点检类别')
        设备编号 && Tyan.doPostEvent('GetRelationInfo', {
            data: { type: '设备编号BLL', objRelationInfo: { '设备': 设备编号, 点检类别 } },
            onEnd: ({ errorMessage, optionsParas, objInfo }) => {
                if (optionsParas) {
                    setState({ optionsParas: { ...me.state.optionsParas, ...optionsParas } })
                    changeItemsValue(this, '基本信息', '点检项目', null)
                }
            }
        })
    }

    const fieldset基本信息 = () => {
        return [
            { _select: '点检设备', name: '设备编号', required: true, minWidth: '95%', editable: true, forceSelection: false, onChange: handlerChange },
            { _radio: '点检类别', required: true, minWidth: '95%', items: ['日常手动', '试验过程'], onChange: handlerChange },
            { _select: '点检项目', required: true, minWidth: '95%', multiSelect: true, },
        ]
    }

    return <Body data={me}
        controls={
            [
                { _button: '保存', icon: '', handler: handleSave, disabled: !bSave() },
                { _button: bChanged() && '取消' || '关闭', icon: '', handler: handlerClose },
            ]
        }
        fieldsets={
            [
                { title: '', name: '基本信息', _fieldset: fieldset基本信息() },
            ]}
    />
}

export default SpotPlanInfo